import { render, staticRenderFns } from "./MoreAboutYourDrinking.vue?vue&type=template&id=ab6fcfcc&scoped=true&"
import script from "./MoreAboutYourDrinking.vue?vue&type=script&lang=ts&"
export * from "./MoreAboutYourDrinking.vue?vue&type=script&lang=ts&"
import style0 from "./MoreAboutYourDrinking.vue?vue&type=style&index=0&id=ab6fcfcc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6fcfcc",
  null
  
)

export default component.exports